import { useClient } from '@composables/use-clients';
import {
  GetRequestArgsType,
  PostRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type GetSkillTreeTenantUserStatesArgsType = GetRequestArgsType & {
  skillTreeCode: string;
  skillTreeTenantUserStateId?: number | null;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type SkillTreeTenantUserStateCompleteArgsType = PostRequestArgsType<any> & {
  skillTreeCode: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type SkillTreeTenantUserStateResetArgsType = PostRequestArgsType<any> & {
  skillTreeCode: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type SkillTreeTenantUserStateSkipArgsType = PostRequestArgsType<any> & {
  skillTreeCode: string;
};

export const apiFetchSkillTreeTenantUserStates = async ({
  domain = useTenantStore().domain,
  skillTreeCode,
  skillTreeTenantUserStateId = null,
  query = {},
  errorConfig = {},
  callbacks = {},
}: GetSkillTreeTenantUserStatesArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.skillTreeTenantUserStates({
        domain,
        skillTreeCode,
        skillTreeTenantUserStateId,
      }),
      query,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiCompleteSkillTree = async ({
  domain = useTenantStore().domain,
  skillTreeCode,
  payload = {},
  errorConfig = {},
  callbacks = {},
}: SkillTreeTenantUserStateCompleteArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.skillTreeTenantUserStateComplete({ domain, skillTreeCode }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiResetSkillTreeState = async ({
  domain = useTenantStore().domain,
  skillTreeCode,
  payload = {},
  errorConfig = {},
  callbacks = {},
}: SkillTreeTenantUserStateResetArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.skillTreeTenantUserStateReset({ domain, skillTreeCode }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiSkipSkillTree = async ({
  domain = useTenantStore().domain,
  skillTreeCode,
  payload = {},
  errorConfig = {},
  callbacks = {},
}: SkillTreeTenantUserStateSkipArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.skillTreeTenantUserStateSkip({ domain, skillTreeCode }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
